import { element } from 'protractor';
import { LogEntry, StorageEntry } from './../shared/services/ledger-entry';
import { Component, OnInit } from '@angular/core';
import { LedgerService } from "../shared/services/ledger.service";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LedgerEntry } from '../shared/services/ledger-entry';
import { AuthService } from '../shared/services/auth.service';
// import { SenseService } from '../shared/services/sense.service';


@Component({
  selector: 'app-sense',
  templateUrl: './sense.component.html',
  styleUrls: ['./sense.component.css']
})
export class SenseComponent implements OnInit {
  // get leadTime for all shipments get logs for each shipment then 
  // get shipment products then avg consumption then
  // x = total stock/avg consumption < leadTime ? order //? public senseService: SenseService,
  ready = false;
  constructor(public authService: AuthService, private db: AngularFirestore, private ledgerService: LedgerService) { }
  ngOnInit() {
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    this.getLedger();
    this.getChartData();
    this.getLeadTime();
    this.getLogs();


    var me = this;
    setTimeout(function () { me.getAvgCons(); }, 800);
    setTimeout(function () { me.getStock(); }, 1500);
    setTimeout(function () { me.displaySense() }, 2100);

    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    this.LedgerEntry.user = this.userProfile.displayName;
    this.LedgerEntry.userEmail = this.userProfile.email;
    this.LedgerEntry.userNumber = this.userProfile.number;

    this.LedgerEntry.userId = this.user.uid;
  }
  displaySense() {
    // this.createBarChart("Ready For Order", this.productsReadyForOrder);

    var me = this;
    Object.keys(this.lead).forEach(function (supplier) {
      // 
      me.logs[supplier]?me.createChart(supplier, me.logs[supplier]):null;
    });
    this.ready = true;
  }
  getDate(element) {
    let unix_timestamp = element.date['seconds']
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    return new Date(unix_timestamp * 1000);
  }
  createSupplierChart(supplier, product) {
    this.chartData[product.code + ' Over Time Stock '] = {
      data: {},
      data1: {},
      data2: {},
      tension: 0.1,
      type: 3,
      type1: 3,
      type2: 3,
      key1: "sale/return",
      key2: "com. Sale",
      sale:true,
      header: 'Months Left ' + (product.timeLeft.toFixed(2) * -1) + ', Stock ' + product.stock + ', AvgCons : ' + product.avgCons
    }
    // display buyers 
    var me = this;
    let comSale = 0;
    product.logs.forEach(element => {
      var today = this.getDate(element); //console.log(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      // var ddd = dd.toString(); var mmm = mm.toString();
      var yyyy = today.getFullYear();
      // if (dd < 10) {
      //   ddd = '0' + dd;
      // }
      // if (mm < 10) {
      //   mmm = '0' + mm;
      // }
      var res = mm + '/' + yyyy;
      switch (this.displayType) {
        case 'h':
          res = today.toString();

          // this should be safe since nothing else in the date string contains a opening paren
          var index = res.indexOf("GMT");

          // if the index exists
          if (~index) {
            res = res.substr(0, index);
          }
          break
        case 'd':
          var res = dd + '/' + mm + '/' + yyyy;

          break
        case 'm':
          var res = mm + '/' + yyyy;
          break
        case 'y':
          var res = yyyy.toString();

          break

      }
      me.chartData[product.code + ' Over Time Stock '].data[res] = element.quantity;
      element.sale != 0 ? me.chartData[product.code + ' Over Time Stock '].data1[res] = element.sale : me.chartData[product.code + ' Over Time Stock '].data1[res] = element.return*-1;
      element.sale != 0 ? comSale += element.sale : comSale += element.return * -1;
      element.sale != 0 ? me.chartData[product.code + ' Over Time Stock '].data2[res] = comSale : me.chartData[product.code + ' Over Time Stock '].data2[res] = comSale;

    });
  }
  createChart(supplier, products) {
    // label: {
    //     data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //     type: 0
    //   }

    this.chartData[supplier + ', Lead Time: ' + this.lead[supplier].leadTime + 'Month(s), Months Left '] = {
      data: {},
      data1: {},
      type: 0,
      type1: 3,
      key1: 'Lead Time'
    }
    this.chartData[supplier + ', Stock '] = {
      data: {},
      data1: {},
      data2: {},
      type: 1,
      type1: 1,
      type2: 1,
      key1: 'Stock Cost',
      key2: 'Cost*Stock'

    }
    this.chartData[supplier + ', Average Consumption '] = {
      data: {},
      type: 4
    }
    this.chartData[supplier + ', Most Sale '] = {
      labels: [],
      data: [],
      type: 2
    }
    this.chartData[supplier + ', Customer '] = {
      labels: [],
      data: [],
      type: 2
    }
    var me = this;
    var msdAlt = {}
    // 
    // let scale = this.getScale(products);
    Object.keys(products).forEach(function (product) {
      msdAlt[product] = 0;
      // products[product].timeLeft > 0 ?
      //  console.log(products, me.lead[supplier].leadTime, products[product].timeLeft);
      products[product].timeLeft >= 0 ?
        me.chartData[supplier + ', Lead Time: ' + me.lead[supplier].leadTime + 'Month(s), Months Left '].data[product] = (-1 * (me.lead[supplier].leadTime - products[product].timeLeft)).toFixed(2) :
        me.chartData[supplier + ', Lead Time: ' + me.lead[supplier].leadTime + 'Month(s), Months Left '].data[product] = (1 * (me.lead[supplier].leadTime - products[product].timeLeft)).toFixed(2);
      me.chartData[supplier + ', Lead Time: ' + me.lead[supplier].leadTime + 'Month(s), Months Left '].data1[product] = me.lead[supplier].leadTime;

      me.chartData[supplier + ', Stock '].data[product] = products[product].stock;
      me.chartData[supplier + ', Stock '].data1[product] = (<StorageEntry>products[product].product).actualCost;
      me.chartData[supplier + ', Stock '].data2[product] = (<StorageEntry>products[product].product).actualCost * products[product].stock;
      me.chartData[supplier + ', Average Consumption '].data[product] = products[product].avgCons;
      me.chartData[supplier + ', Most Sale '].labels.push(product);
      let mSD = { 'Unit Sale': products[product].totalSale, 'Retail Sale': products[product].totalRetailSale, 'Gross Sale': products[product].totalGrossSale, 'Cost of Sale': products[product].totalCostSale };

      //mSD['Unit Sale scaled by' + scale + 'x'] = scale * products[product].totalSale;
      me.chartData[supplier + ', Most Sale '].data.push(mSD);
      // me.chartData[supplier + ', Lead Time: ' + me.lead[supplier].leadTime + 'Month(s), Most Sale '].data[1];
      // me.chartData[supplier + ', Lead Time: ' + me.lead[supplier].leadTime + 'Month(s), Most Sale '].data[2]['Gross Sale'] = products[product].totalGrossSale;

      // : null;
      // console.log(me.chartData, products, products[product].timeLeft)
    });
    Object.keys(this.buyers).forEach(function (buyer) {
      let mSDAlt = JSON.parse(JSON.stringify(msdAlt))
      me.chartData[supplier + ', Customer '].labels.push(buyer);
      me.buyers[buyer].forEach(log => {
        mSDAlt[log.code] += log.sale;
      })
      //mSD['Unit Sale scaled by' + scale + 'x'] = scale * products[product].totalSale;
      me.chartData[supplier + ', Customer '].data.push(mSDAlt);
      // Object.keys(msdAlt).forEach(function (product) { msdAlt[product] = 0; })
    });
    //  console.log(this.chartData);
    this.getChartData();
  }
  getScale(products) {
    var me = this;
    let scale = 10;
    let productScale = 10;
    // 
    Object.keys(products).forEach(function (product) {
      let avg = Math.floor(
        ((
          me.getLength(
            products[product].totalRetailSale) +
          me.getLength(
            products[product].totalGrossSale) +
          me.getLength(scale))
          / 3))
      scale = Math.pow(10, avg)
      productScale = Math.pow(10, Math.floor((me.getLength(products[product].totalSale) + me.getLength(productScale)) / 2))
    });

    return (Math.pow(10, Math.floor(this.getLength(scale) - this.getLength(productScale))))
  }
  getLength(number) {
    return number.toString().length;
  }
  getStock() {
    let collection = this.db.collection("generalStorage")
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as StorageEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          if (this.logs[data.supplier][data.code]) {
            this.logs[data.supplier][data.code].stock = data.quantity;
            this.logs[data.supplier][data.code].product = data;
            this.logs[data.supplier][data.code].timeLeft = this.lead[data.supplier].leadTime - (data.quantity / this.logs[data.supplier][data.code].avgCons)
            this.logs[data.supplier][data.code].timeToOrder = this.lead[data.supplier].leadTime >= (data.quantity / this.logs[data.supplier][data.code].avgCons)
            // this.logs[data.supplier][data.code].timeToOrder ? this.logs[data.supplier][data.code].timeLeft = this.lead[data.supplier].leadTime - this.logs[data.supplier][data.code].timeLeft : null;
            this.logs[data.supplier][data.code].timeToOrder ? this.productsReadyForOrder.push({ avgCons: this.logs[data.supplier][data.code].avgCons, leadTime: this.lead[data.supplier].leadTime, timeLeft: this.logs[data.supplier][data.code].timeLeft, data }) : null;
          }//Use spread operator to add the id to the document data
          return { id, data };
        });
      });
  }
  //   The formula for calculating CA
  // is:
  // CA
  //  = CT
  //  ÷ [RM
  //  – (DOS ÷ 30.5)]
  // where:
  // CT
  //  = total consumption during the review period
  // RM
  //  = total consumption review period, in months
  // DOS = number of days an item was out of stock during the review period
  // 30.5 = average number of days in a month.
  getAvgCons() {
    var me = this;
    Object.keys(this.logs).forEach(function (supplier) {
      //var value = data[key];
      var that = me;
      //  console.log(me.logs)
      Object.keys(me.logs[supplier]).forEach(function (code) {
        //var value = data[key];
        let totalSale = 0;
        let period = 0;//in month
        let dates = [];
        let leadTime = that.lead[supplier].leadTime;
        let today = new Date();
        let startDate = that.subMonths(today, leadTime);
        var who = that;
        that.logs[supplier][code].logs.forEach(element => {
          if (that.getDate(element).getTime() > startDate.getTime())
            totalSale += element.sale;
          totalSale -= element.return;
          element.type == "sale" ?
            dates.push(element.date) :
            // element.type == "new" ?
            //   max = new Date(Math.min.apply(null, [max, who.getDate(element)])) :
            null;
          // console.log(Math.min.apply(null, [max, who.getDate(element)]), who.getDate(element));
        });// max date? 
        // var maxDate = new Date(Math.max.apply(null, dates));
        // var minDate = new Date(Math.min.apply(null, dates));
        var maxDate = new Date();
        // var minDate = new Date(max);


        dates.length ? null : period = that.monthDiff(startDate, maxDate);
        //  console.log(supplier, code, totalSale, period, startDate, maxDate);
        period == 0 ? that.logs[supplier][code].avgCons = totalSale : that.logs[supplier][code].avgCons = totalSale / period;
      });
    });
  }
  subMonths(date, months) {
    var d = date.getDate();
    date.setMonth(date.getMonth() - months);
    return date;
  }

  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }
  buyers = {}
  getLogs() {
    let collection = this.db.collection("generalLog", ref => ref.where('type', '==', "sale"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LogEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.logs[data.supplier] ? null : this.logs[data.supplier] = {};
          this.logs[data.supplier][data.code] ? null : this.logs[data.supplier][data.code] = { logs: [], avgCons: 0, code: data.code, name: data.name, totalSale: 0, totalRetailSale: 0, totalGrossSale: 0, totalCostSale: 0 };
          this.logs[data.supplier][data.code].totalSale += data.sale;
          this.logs[data.supplier][data.code].totalRetailSale += (data.sale * data.retailPrice);
          this.logs[data.supplier][data.code].totalCostSale += (data.sale *  data.actualCost);
          this.logs[data.supplier][data.code].totalGrossSale += (data.sale * (data.retailPrice - data.actualCost));
          this.logs[data.supplier][data.code].logs.push(data);
          this.logs[data.supplier][data.code].logs.sort(function (a, b) { return a.date - b.date });//? check sort is desc?
          
          this.buyers[data.buyer] ? null : this.buyers[data.buyer] = [];
          this.buyers[data.buyer] ? this.buyers[data.buyer].push(data) : null;

          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    //  console.log(this.logs);

    collection = this.db.collection("generalLog", ref => ref.where('type', '==', "new"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LogEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.logs[data.supplier] ? null : this.logs[data.supplier] = {};
          this.logs[data.supplier][data.code] ? null : this.logs[data.supplier][data.code] = { logs: [], avgCons: 0, code: data.code, name: data.name, totalSale: 0, totalRetailSale: 0, totalGrossSale: 0, totalCostSale: 0 };
          this.logs[data.supplier][data.code].logs.push(data);
          this.logs[data.supplier][data.code].logs.sort(function (a, b) { return a.date - b.date });//? check sort is desc?
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    collection = this.db.collection("generalLog", ref => ref.where('type', '==', "return"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LogEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.logs[data.supplier] ? null : this.logs[data.supplier] = {};
          this.logs[data.supplier][data.code] ? null : this.logs[data.supplier][data.code] = { logs: [], avgCons: 0, code: data.code, name: data.name, totalSale: 0, totalRetailSale: 0, totalGrossSale: 0, totalCostSale: 0 };
          this.logs[data.supplier][data.code].totalSale -= data.return;
          this.logs[data.supplier][data.code].totalRetailSale -= (data.return * data.retailPrice);
          this.logs[data.supplier][data.code].totalCostSale -= (data.return *  data.actualCost);
          this.logs[data.supplier][data.code].totalGrossSale -= (data.return * (data.retailPrice - data.actualCost));
          this.logs[data.supplier][data.code].logs.push(data);
          this.logs[data.supplier][data.code].logs.sort(function (a, b) { return a.date - b.date });//? check sort is desc?
          data.sale = data.return * -1;
          this.buyers[data.buyer] ? this.buyers[data.buyer].push(data) : this.buyers[data.buyer] = [];

          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    //  console.log(this.logs);

  }
  getLeadTime() {
    //let leadTime = 0;// ref => ref.where('supplier', '==', supplier)
    let collection = this.db.collection("generalSupplier")
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data();
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.lead[data.supplier] = { leadTime: data.leadTime, supplier: data.supplier };
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
  }
  displayType = "m";
  lead = {};
  logs = {};
  userProfile;
  user;
  addingNew = true;
  backup = false;
  fullView = false;
  incomeStatement = { "container": [], "directCost": [], "directCostCr": [], "sales": [], "totalSales": 0, "exp": [], "taxes": [], "zero": [], "totalZero": 0, "expOp": [], "totalExpOp": 0, "expOpCr": [], "totalExpOpCr": 0, "totalTaxes": 0, "totalExp": 0, "totalContainer": 0, "totalDirectCost": 0, "totalDirectCostCr": 0, "totalCogs": 0 };
  ledger: Observable<any[]>;
  fileReaded: any;
  safeToFilter: boolean = true;

  totalDebit = 0; totalCredit = 0;
  myEntry: string;
  editMode: boolean = false;
  entryToEdit: any = {};
  autoComplete = {
    supplier: {},
  };
  autoCompleteKeys = {

    supplier: {},

  };
  productsReadyForOrder = [];
  chartDataDuplicate = {};
  chartData = {
    // label: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 0
    // },
    // labelOne: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 1
    // },
    // labelTwo: {
    //   labels: ['one', 'two'],
    //   data: [
    //     { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //     { Red: 6, Blue: 10, Yellow: 5, Green: 14, Purple: 16, Orange: 2 }
    //   ],
    //   type: 2
    // },
    // labelFour: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 3
    // },
    // labelFive: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 4
    // },
    // labelSix: {
    //   data: [{ x: 12, y: 19, r: 9 }, { x: 4, y: 16, r: 10 }],
    //   type: 5
    // }
  };
  chartDataString = JSON.stringify(this.chartData);
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = [];
  LedgerEntry: LedgerEntry = {
    id: "",
    TXN: "",
    supplier: "",
    shipmentNumber: 0,
    codeCredit: "",
    codeDebit: "",
    creditName: "",
    creditValue: 0,
    date: new Date(),
    debitName: "",
    debitValue: 0,
    cashFlow: 0,
    comment: "",
    user: "",
    userId: "",
    userEmail: "",
    userNumber: "",
  }
  generalLedgerCollection = { generalLedger: [] };
  getChartData() {
    this.chartDataString = JSON.stringify(this.chartData);
    setTimeout(function () {
      (<HTMLInputElement>document.getElementById("initChart")).click();
    }, 500);
  }
  // Math.round((num + Number.EPSILON) * 100) / 100
  addNew() {
    if (this.addingNew) {
      //(<HTMLInputElement>document.getElementById('addForm')).className = "col s12";
      this.addingNew = !this.addingNew;
    } else {
      //(<HTMLInputElement>document.getElementById('addForm')).className = "col s1";
      this.addingNew = !this.addingNew;

    }
  }
  showBackup() {
    this.backup = !this.backup;
  }
  getFullView() {
    this.fullView = !this.fullView;
  }

  roundValue(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100
  }
  changeSelect(s) {
    console.log(s);
    
   }
  getLedger() {
    this.ledger = this.db.collection("generalLedger").snapshotChanges().pipe(map(actions => {

      return actions.map(a => {
        //Get document data
        const data = a.payload.doc.data() as LedgerEntry;

        //Get document id
        const id = a.payload.doc.id;
        //console.log(data);
        this.addAutoComplete(data)
        this.generalLedgerCollection.generalLedger.push(data);
        let unix_timestamp = data.date['seconds']
        // Create a new JavaScript Date object based on the timestamp
        // multiplied by 1000 so that the argument is in milliseconds, not seconds.
        var date = new Date(unix_timestamp * 1000); //console.log(date);
        // Hours part from the timestamp
        var hours = date.getHours();
        // Minutes part from the timestamp
        var minutes = "0" + date.getMinutes();
        // Seconds part from the timestamp
        var seconds = "0" + date.getSeconds();

        // Will display time in 10:30:23 format
        var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
        Math.abs(2 % 2) == 1
        //Use spread operator to add the id to the document data
        return { id, date, data };
      });
    }));
  }
  isToday(dateParameter) {
    var today = new Date();
    return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
  }
  updateValueOnAutocomplete() {
    let me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];

      let val = (<HTMLInputElement>document.getElementById('autocomplete' + key)).value;

      if (val) {
        if (key != 'shipmentNumber') {
          me.LedgerEntry[key] = val;
        }
        else {
          me.LedgerEntry[key] = Number.parseFloat(val);
        }
        //console.log(me.LedgerEntry[key]);
      }
      //


    });
    this.getShipmentSense()
  }
  addAutoComplete(data) {
    var me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];
      if (me.autoComplete[key][data[key]] != "" && data[key] != "") {
        me.autoComplete[key][data[key]] = "";
        me.autoCompleteArray.push(data[key]);

      }

    });
    me.autoCompleteString = JSON.stringify(me.autoComplete);
    //console.log(this.autoComplete);
  }
  shipmentSense = true;
  getShipmentSense() {
    if (this.autoCompleteArray.includes(this.LedgerEntry.supplier)) {
      this.shipmentSense ? this.chartDataDuplicate = JSON.parse(JSON.stringify(this.chartData)) : null;
      this.shipmentSense ? this.shipmentSense = false : null;
      this.chartData = {};
      var me = this; let supplier = this.LedgerEntry.supplier;
      Object.keys(me.logs[supplier]).forEach(function (product) {
        me.createSupplierChart(supplier, me.logs[supplier][product]);
      });
      this.getChartData();

    } else {
      !this.shipmentSense ? this.chartData = JSON.parse(JSON.stringify(this.chartDataDuplicate)) : null;
      !this.shipmentSense ? this.shipmentSense = true : null;

      this.getChartData();
    }
  }

}
